// removed by extract-text-webpack-plugin
module.exports = {"SalesSummary":"SalesSummary__SalesSummary__14CVR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/SalesSummary/SalesSummary.css
// module id = 202
// module chunks = 1